import { AutocompleteItem } from '../../components/autocomplete/autocomplete-service'
export class DashboardQuickSearch {

	navigateToItem(item: AutocompleteItem) {
		console.log(item);

		const url = item.url;
		if (url) {
			window.location.href = url;
		}
	}
}

